export const serviceTableCols = [
  {
    value: 'rank',
    label: 'Rank',
    headerAlign: 'left',
    valueAlign: 'left',
  },
  {
    value: 'advisor',
    label: 'Advisor name',
    headerAlign: 'left',
    valueAlign: 'left',
  },
  {
    value: 'roCount',
    label: 'No. of ROs',
    headerAlign: 'right',
    valueAlign: 'right',
  },
  {
    value: 'roItems',
    label: 'RO items',
    headerAlign: 'center',
    valueAlign: 'center',
  },
  {
    value: 'total',
    label: 'Total amount',
    headerAlign: 'right',
    valueAlign: 'right',
    format: 'price',
  },
  {
    value: 'approved',
    label: 'Amount approved',
    headerAlign: 'right',
    valueAlign: 'right',
    format: 'price',
  },
  {
    value: 'closeRatio',
    label: 'Close ratio',
    valueAlign: 'right',
    headerAlign: 'right',
    format: 'percent',
  },
];

export const serviceExportTableCols = [
  {
    value: 'rank',
    label: 'Rank',
  },
  {
    value: 'advisor',
    label: 'Advisor name',
  },
  {
    value: 'roCount',
    label: 'No. of ROs',
  },
  {
    value: 'roiTotal',
    label: 'RO total',
  },
  {
    value: 'roiReq',
    label: 'RO req.',
  },
  {
    value: 'roiOpt',
    label: 'RO opt.',
  },
  {
    value: 'total',
    label: 'Total amount',
    format: 'price',
  },
  {
    value: 'approved',
    label: 'Amount approved',
    format: 'price',
  },
  {
    value: 'closeRatio',
    label: 'Close ratio',
    format: 'percent',
  },
];

export const serviceColumnWidths = [35, 80, 80, 100, 100, 120, 75];

export const salesTableCols = [
  {
    value: 'rank',
    label: 'Rank',
    headerAlign: 'center',
    valueAlign: 'center',
  },
  {
    value: 'advisor',
    label: 'Sales Rep.',
    headerAlign: 'center',
    valueAlign: 'center',
  },
  {
    value: 'recorded',
    label: 'Recorded',
    headerAlign: 'center',
    valueAlign: 'center',
  },
  {
    value: 'sent',
    label: 'Sent',
    headerAlign: 'center',
    valueAlign: 'center',
  },
  {
    value: 'views',
    label: 'Views',
    headerAlign: 'center',
    valueAlign: 'center',
  },
  {
    value: 'engagement',
    label: 'Engagement',
    headerAlign: 'center',
    valueAlign: 'center',
    format: 'percent',
  },
  {
    value: 'duration',
    label: 'Avg Video Duration (Seconds)',
    headerAlign: 'center',
    valueAlign: 'center',
  },
  {
    value: 'marketing',
    label: 'Marketing',
    valueAlign: 'center',
    headerAlign: 'center',
  },
  {
    value: 'prospecting',
    label: 'Prospecting',
    valueAlign: 'center',
    headerAlign: 'center',
  },
  {
    value: 'rti',
    label: 'RTI',
    valueAlign: 'center',
    headerAlign: 'center',
  },
  {
    value: 'tyfb',
    label: 'TYFB',
    valueAlign: 'center',
    headerAlign: 'center',
  },
];

export const salesExportTableCols = [
  {
    value: 'rank',
    label: 'Rank',
  },
  {
    value: 'advisor',
    label: 'Sales Rep.',
  },
  {
    value: 'recorded',
    label: 'Recorded',
  },
  {
    value: 'sent',
    label: 'Sent',
  },
  {
    value: 'views',
    label: 'Views',
  },
  {
    value: 'engagement',
    label: 'Engagement',
    format: 'percent',
  },
  {
    value: 'duration',
    label: 'Avg Video Duration (Seconds)',
  },
  {
    value: 'marketing',
    label: 'Marketing',
  },
  {
    value: 'prospecting',
    label: 'Prospecting',
  },
  {
    value: 'rti',
    label: 'RTI',
  },
  {
    value: 'tyfb',
    label: 'TYFB',
  },
];

export const salesColumnWidths = [45, 190, 75, 75, 75, 80, 80, 80, 80, 80, 80];
